import { z } from "zod";

export const JurisdictionTypeEnum = z.enum(["county", "city", "village", "township", "school"]);

export const JurisdictionStatusEnum = z.enum(["active", "paused", "broken"]);

export const JurisdictionPlatformEnum = z.enum([
  "civicplus",
  "granicus",
  "legistar",
  "municode",
  "civicclerk",
  "civicengage",
  "icompass",
  "llm_generic",
  "unknown",
]);

export const JurisdictionSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  type: JurisdictionTypeEnum,
  parentId: z.string().uuid().nullable(),
  fips: z.string().optional().nullable(),
  primaryWebsite: z.string().url().optional().nullable(),
  platform: JurisdictionPlatformEnum.optional().nullable(),
  config: z.record(z.string(), z.unknown()).optional().nullable(),
  contactEmail: z.string().email().optional().nullable(),
  status: JurisdictionStatusEnum,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type Jurisdiction = z.infer<typeof JurisdictionSchema>;
